import { ISurvey, IUser } from '@legacy/types';

export const isUserEmailVerified = (
  survey: ISurvey | null,
  user: IUser | undefined,
  count: number
) => {
  return survey?.userRole === 'participant' && !user?.email_verified_at && count === 1;
};
